<template>
  <div class="accept-container">
    <Navbar></Navbar>
    <!--<div class="go-back" v-show="goBackState" @click="goBack">GoBack</div>-->
    <!--<ul>-->
      <!--<li v-for="item in webAddress">-->
        <!--<a :href="item.link" target="showHere" @click="showIframe">{{item.name}}</a>-->
      <!--</li>-->
    <!--</ul>-->
    <iframe  id="show-iframe"
             frameborder=0 name="showHere"
             scrolling=auto :src='this.url'></iframe>
  </div>
</template>

<script>
  import Navbar from '../components/Navbar'
  export default {
    components:{Navbar},
    data() {
      return {
          url: ''
      }
    },
    mounted() {
      // this.url = '//wiki.swarma.net/index.php/%E5%BD%A9%E4%BA%91%E5%B0%8F%E8%AF%91API'
      this.url = 'http://open.caiyunapp.com/%E4%BA%94%E5%88%86%E9%92%9F%E5%AD%A6%E4%BC%9A%E5%BD%A9%E4%BA%91%E5%B0%8F%E8%AF%91_API'
      this.screen()
      window.onresize = () => {
        this.screen()
      }
    },
    methods: {
      screen: function () {
        const oIframe = document.getElementById('show-iframe')
        const deviceWidth = document.documentElement.clientWidth
        const deviceHeight = document.documentElement.clientHeight
        oIframe.style.width = deviceWidth + 'px'
        oIframe.style.height = ( deviceHeight > 600 ?  deviceHeight - 60 : 600 - 60 ) + 'px';
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/api.vue